import { Box } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import StoryForm from './StoryForm';

const StoriesDetailsForm = ({ story, onBack, onSuccess, onCopy, del }) => {
  const fetch = useFetch();

  const [segments, setSegments] = useState();
  const [pages, setPages] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const { accountId, domainId } = useParams();

  useEffect(() => {
    Promise.all([
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`),
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages`),
    ])
      .then(([{ segments }, { pages }]) => {
        setSegments(segments);
        setPages(pages);
      })
      .catch(setLoadError);
  }, [fetch, accountId, domainId]);

  const update = (storyData) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/stories/${story.id}`, {
      method: 'PUT',
      body: JSON.stringify(storyData),
    })
      .then(({ story }) => onSuccess(story))
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (story === undefined || segments === undefined || pages === undefined) {
    return <Spinner />;
  }

  return (
    <>
      <StoryForm
        story={{
          ...story,
          slides: story.storySlides || [],
        }}
        segments={segments}
        pages={pages}
        saveStory={update}
        deleteStory={del}
        cancel={onBack}
        copyStory={onCopy}
      />
      {userError ? (
        <Box ta="right">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default StoriesDetailsForm;
